import React from "react";
import {
  urlImageSign,
  firmaColaboradorApariencia,
  getAuthorizationHeader,
  username,
  idEmpresa,
} from "../../constans/constants";
import { URL as Link } from "../../constans/constants";
import Resizer from "react-image-file-resizer";
import {
  inicializar,
  joinDetails,
  reload,
  get,
  create,
  remove,
  stringify,
} from "../../components/tiposDocumento/AparienciaServicios";
import {
  informacionTramite,
  reasignarTramite,
  rechazarTramite,
  obtenerFormatoFirmaSolicitante,
} from "./TramitesService";
import axios from "axios";
import PinTramite from "./PinTramite";
import SeleccionPca from "../../components/pca/SeleccionPca";
import { Cookies } from "react-cookie";
import checkCircle from "../../styles/icons/check-circle.svg";
import xCircle from "../../styles/icons/x-circle.svg";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import ModalMensajePersonalizado from "../componentes/modales/ModalMensajesPersonalizado";
import ModalReasignarTramite from "./ModalReasignarTramite";
import ModalRechazarRecibo from "../../components/recibos/ModalRechazarRecibo";

class FirmarTramite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoFirma: [],
      idTipoFirma: "",
      tipoAparienciaEmpleado: [],
      idTipoAparienciaEmpleado: 1,
      tipoDetalleEmpleado: [],
      idTipoDetalleEmpleado: 0,
      usuarioDetalle: [],
      idUsuarioDetalle: "",
      fileImagenEmpleado: null,
      urlImagenEmpleado: urlImageSign,
      urlImagenEmpleadoMostrar: urlImageSign,
      urlImageFirmaColaborador: firmaColaboradorApariencia,
      urlImageFirmaColaboradorMostrar: firmaColaboradorApariencia,
      filePDF: null,
      urlPDF: null,
      containerHeight: 200,
      pageNumber: null,
      openSeleccionPca: false,
      openLoginPSA: false,
      configEmpleado: {},
      base64StampEmpleado: urlImageSign.replace(
        /^data:image\/(png|jpg|jpeg);base64,/,
        ""
      ),
      stampEmpleado: { type: "png" },
      signEmpleado: {
        id: 1,
        name: "Empleado",
        page: 1,
        color: "#30E156",
        detailType: "",
        details: "",
        stamp: "",
        freeText: "",
        appearance: "",
      },
      dialogPinOpen: localStorage.getItem("tokenIscert") != null ? true : false,
      pcaActivos: [],
      nombreTramite: "",
      mensajeRechazar: "",
      openRechazar: false,
      isRechazado: false,
      validated: false,
      openMsgVentana: false,
      fechaCarga: "",

      msgVentana: "",
      error: false,
      openPantallaCarga: false,
      msgPantallaCarga: "",
      redirect: false,
      botonRechazar: false,
      pantallaAnterior: localStorage
        .getItem("urlRaiz")
        .substring(localStorage.getItem("urlRaiz").indexOf("#") + 1),
      ventanaReasignar: false,
      miembros: [],
      idMiembroReasignado: 0,
      tieneAdjunto: false,
      supervisores: [],
      esSolicitante: false,
    };
    this.modalRechazarRecibo = React.createRef();
    this.modalSeleccionPsa = React.createRef();
    this.modalReasignarTramite = React.createRef();
  }

  componentDidMount() {
    const detallesEmpleado = [
      { id: 1, name: "Imagen" },
      { id: 2, name: "Texto" },
      { id: 3, name: "Texto-Imagen" },
      { id: 4, name: "Firma Colaborador" },
    ];
    const usuarioDetalle = [
      { id: "${ci}", name: "CI", check: false },
      { id: "${nombre_apellidos}", name: "Nombre y Apellidos", check: false },
      /*       { id: "${lugar}", name: "Lugar", check: false }, */
    ];
    this.setState({
      tipoDetalleEmpleado: detallesEmpleado,
      usuarioDetalle: usuarioDetalle,
    });

    this.getBase64FromUrl(urlImageSign).then((result) => {
      this.setState({ base64StampEmpleado: result });
    });
    // myBase64 is the base64 string
    axios
      .get(Link + "tramite/" + this.props.match.params.idTramite, {
        ...getAuthorizationHeader(),
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const reader = new FileReader();
        reader.onloadend = () => {
          const arrayBuffer = reader.result;
          const uint8Array = new Uint8Array(arrayBuffer);
          this.setState({ filePDF: uint8Array });
          this.generarpdf(uint8Array);
        };
        reader.readAsArrayBuffer(blob);
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
      });
    axios
      .get(Link + "pca/obtener", getAuthorizationHeader())
      .then((response) => {
        this.setState({ psaActivos: response.data.datos });
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
      });
    informacionTramite(this.props.match.params.idTramite).then((resp) => {
      if (!resp.error) {
        this.setState({
          nombreTramite: resp.datos.nombre,
          fechaCarga: resp.datos.fechaCarga,
          botonRechazar: resp.datos.rechazarTramite,
          tieneAdjunto: resp.datos.tieneAdjunto,
          supervisores: resp.datos.supervisores,
          esSolicitante: resp.datos.username === username(),
        });
      }
    });
  }

  handleClose = () => {
    this.props.handleClose(false);
  };

  handleClosePsa = () => {
    this.setState({ openSeleccionPca: false });
  };

  handleLoginPSA = (value, data) => {
    if (data != null) {
      if (data.error) {
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: true,
          msgVentana: data.mensaje,
        });
      } else {
        localStorage.setItem("tokenIscert", data.datos.access_token);
        localStorage.setItem("codigoClienteFirma", this.datosPsa.id);
        localStorage.setItem("proveedorFirma", this.datosPsa.codigoCliente);
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: false,
          msgVentana: "Autenticado con exito",
        });
      }
    } else {
      this.setState({
        openLoginPSA: value,
      });
    }
  };

  getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data.replace(/^data:image\/(png|jpg|jpeg);base64,/, ""));
      };
    });
  };

  /*-----------------------PDF-----------------------------------*/
  onDocumentComplete = this.onDocumentComplete.bind(this);
  onDocumentComplete(pages) {
    this.setState({ page: 1, pages });
  }
  onChangeFilePDF = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      const arrayBuffer = reader.result;
      const uint8Array = new Uint8Array(arrayBuffer);
      this.setState({ filePDF: uint8Array });
      this.generarpdf(uint8Array);
    };
    reader.readAsArrayBuffer(file);
  };

  generarpdf = (pdfData) => {
    GlobalWorkerOptions.workerSrc = `${window.location.origin}/mirecibo/visor/pdf.worker.js`;
    var canvasContainer = document.querySelector(".canvas-container");
    if (canvasContainer != null) {
      var upperCanvas = document.querySelector(".upper-canvas");
      if (upperCanvas) {
        canvasContainer.removeChild(upperCanvas);
      }
    }

    const loadingTask = getDocument({ data: pdfData });
    loadingTask.promise.then(
      (pdf) => {
        const pageNumber = 1;
        pdf.getPage(pageNumber).then((page) => {
          const scale = 1;
          const viewport = page.getViewport({ scale: scale });

          const canvas = document.getElementById("the-canvas");
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          const renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          const renderTask = page.render(renderContext);
          renderTask.promise.then(() => {
            inicializar(canvas);
          });
        });
      },
      (reason) => {
        console.error("Error loading PDF:", reason);
      }
    );
  };
  /*---------------Fin PDF---------------------*/

  /*---------------Imagen----------------------*/
  getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  /*------------------Fin Imagen-----------------*/

  /*--------------------Colaborador-----------------*/
  handeCheckEmpleado = (e) => {
    var detallesTextAux = [];
    var datosActualizar = this.state.usuarioDetalle;
    datosActualizar.forEach((detalle) => {
      if (e.target.value == detalle.id) {
        detalle.check = e.target.checked;
      }
      if (detalle.check) {
        detallesTextAux.push(detalle);
      }
    });
    this.actualizarCanvasEmpleado(detallesTextAux);
    this.setState({ usuarioDetalle: datosActualizar });
  };

  actualizarCanvasEmpleado = (text) => {
    var urlImage = undefined;
    if (
      this.state.idTipoDetalleEmpleado == 1 ||
      this.state.idTipoDetalleEmpleado == 3
    ) {
      urlImage = this.state.urlImagenEmpleado;
    }
    if (this.state.idTipoDetalleEmpleado == 4) {
      urlImage = this.state.urlImageFirmaColaborador;
    }
    var config = {
      id: 1,
      borderColor: "#30E156",
      text: joinDetails("", text),
      stampUrl: urlImage,
    };
    this.setState({ configEmpleado: config });
    reload(config);
    var typeDetails = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );
    var details = this.state.usuarioDetalle.filter(
      (detalle) => detalle.check == true
    );
    this.setState({
      signEmpleado: {
        id: 1,
        page: 1,
        name: "Empleado",
        color: "#30E156",
        detailType: typeDetails,
        details: details,
        stamp: urlImage,
        appearance: get(1),
      },
    });
  };

  handleUploadLogoEmpleado = (event) => {
    event.preventDefault();
    this.setState({ fileImagenEmpleado: event.target.files[0] });
    this.setState({
      urlImagenEmpleado: URL.createObjectURL(event.target.files[0]),
      stampEmpleado: event.target.files[0],
    });
    this.asignarBase64Empleado(event.target.files[0]);
    var urlImage = URL.createObjectURL(event.target.files[0]);
    try {
      Resizer.imageFileResizer(
        event.target.files[0],
        250,
        200,
        "PNG",
        0,
        0,
        (uri) => {
          this.setState({
            urlImagenEmpleadoMostrar: URL.createObjectURL(uri),
          });
        },
        "file"
      );
    } catch (error) { }
    this.createCanvasImageEmpleado(urlImage);
  };

  createCanvasImageEmpleado(urlImageSign) {
    var config = {
      id: 1,
      stampUrl: urlImageSign,
      borderColor: "#30E156",
    };
    this.setState({ configEmpleado: config });
    var typeDetails = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );
    var details = this.state.usuarioDetalle.filter(
      (detalle) => detalle.check == true
    );

    create(config);
    this.setState({
      signEmpleado: {
        id: 1,
        page: 1,
        name: "Empleado",
        color: "#30E156",
        detailType: typeDetails,
        details: details,
        stamp: urlImageSign,
        appearance: get(1),
      },
    });
  }

  createCanvasTextEmpleado(text) {
    var config = {
      id: 1,
      stampUrl: undefined,
      borderColor: "#30E156",
      text: joinDetails("", text),
    };
    this.setState({ configEmpleado: config });
    var typeDetails = this.state.tipoDetalleEmpleado.find(
      (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
    );
    var details = this.state.usuarioDetalle.filter(
      (detalle) => detalle.check == true
    );
    create(config);
    this.setState({
      signEmpleado: {
        id: 1,
        page: 1,
        name: "Empleado",
        color: "#30E156",
        detailType: typeDetails,
        details: details,
        stamp: undefined,
        appearance: get(1),
      },
    });
  }

  clearCheckEmpleado = () => {
    var datosActualizar = this.state.usuarioDetalle;
    datosActualizar.forEach((detalle) => {
      detalle.check = false;
    });
    this.setState({ usuarioDetalle: datosActualizar });
  };

  asignarBase64Empleado = (file) => {
    this.getBase64(file)
      .then((result) => {
        file["base64"] = result;
        this.setState({
          base64StampEmpleado: result,
        });
      })
      .catch((err) => {
      });
  };

  /*-------------------Fin Colaborador----------------------------*/

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
    if (name == "idTipoDetalleEmpleado" && val == 2) {
      this.createCanvasTextEmpleado([
        {
          id: "${mirecibo}",
          name: "mirecibo",
          check: true,
        },
      ]);
    }
    if (
      (name == "idTipoDetalleEmpleado" && val == 1) ||
      (name == "idTipoDetalleEmpleado" && val == 3)
    ) {
      this.createCanvasImageEmpleado(this.state.urlImagenEmpleado);
    }
    if (name == "idTipoDetalleEmpleado" && val == 4) {
      this.createCanvasImageEmpleado(this.state.urlImageFirmaColaborador);
    }
    if (name == "idTipoAparienciaEmpleado" && val == 1) {
      remove(1);
      this.clearCheckEmpleado();
      this.setState({ idTipoDetalleEmpleado: "" });
    }
  };

  descargarAdjunto = () => {
    window.location.href =
      URL +
      "tramite/adjuntos/" +
      this.props.match.params.idTramite +
      "/descargar";
  };

  guardar = async () => {
    try {
      if (this.state.esSolicitante) {
        const data = await obtenerFormatoFirmaSolicitante(
          this.props.match.params.idTramite,
          username()
        );
        if (!data || data.error || !data.datos) {
          this.setState({
            msgVentana: "No hay una apariencia de firma configurada para este tipo de solicitud. Contacte al administrador.",
            openMsgVentana: true,
            error: true,
          });
          return;
        }
        localStorage.setItem("aparienciaFirmaTramite", data.datos);
        this.handleDialogPin(true, null);
        return;
      }

      await this.reloadCanvas;

      if (this.state.idTipoDetalleEmpleado == 2) {
        this.setState((prevState) => ({
          ...prevState,
          signEmpleado: {
            ...prevState.signEmpleado,
            appearance: get(1),
          },
        }));
      }

      let typeDetailEmpleado = this.state.tipoDetalleEmpleado.find(
        (tipo) => tipo.id == this.state.idTipoDetalleEmpleado
      );

      let jsonEmpleado = await stringify(
        typeDetailEmpleado,
        this.state.signEmpleado,
        this.state.stampEmpleado,
        this.state.base64StampEmpleado
      );

      const data = await this.firmaFormateada(jsonEmpleado);

      const cookies = new Cookies();
      localStorage.setItem("aparienciaFirmaTramite", data.datos);

      this.handleDialogPin(true, null);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  firmaFormateada = async (apariencia) => {
    try {
      const response = await axios.post(
        Link + "tramite/formatoFirma/" + username(),
        apariencia,
        getAuthorizationHeader()
      );
      return response.data;
    } catch (error) {
      console.error("Error al realizar la petición:", error);
      throw error;
    }
  };

  reloadCanvas() {
    reload(this.state.configEmpleado);
  }
  verificarPdfReferencia = () => {
    if (!this.state.filePDF && this.state.idTipoAparienciaEmpleado == 2) {
      return true;
    } else {
      return false;
    }
  };

  handleDialogPin = (open, data) => {
    if (localStorage.getItem("tokenIscert") == null) {
      this.setState({ openSeleccionPca: true });
      return;
    }

    localStorage.removeItem("tokenIscert");
    localStorage.removeItem("codigoClienteFirma");
    localStorage.removeItem("proveedorFirma");
    if (data.error) {
      this.setState({
        msgVentana: data.mensaje,
        openMsgVentana: true,
        error: data.error
      });
    } else {
      this.setState({ dialogPinOpen: open });
      this.props.history.push({
        pathname: '/tramite/firmar/' + (data.error ? 'error' : 'exito'),
        state: {
          nombreDocumento: this.state.nombreTramite,
          destinatario: this.state.supervisores,
          errorDetalle: data.mensaje,
          backUrl: this.props.location.pathname
        }
      });
    }
  };

  handleMsgVentana = (value) => {
    !value
      ? this.modalMensaje.current.cerrarModalConAnimacion()
      : this.setState({ openMsgVentana: value, redirect: true });

  };

  armarUrlRedireccion = () => {
    return localStorage
      .getItem("urlRaiz")
      .substring(localStorage.getItem("urlRaiz").indexOf("#") + 1);
  };

  rechazarTramiteAccion = () => {
    rechazarTramite(this.props.match.params.idTramite, this.state.mensajeRechazar).then((response => {
      this.props.history.push({
        pathname: '/bandeja/rechazados',
        state: {
          mensajeFlash: !response.error ? 'Documento rechazado exitosamente' : 'Ocurrio un error al rechazar documento',
          mostrarMensajeFlash: true,
          mensajeFlashSeverity: response.error ? 'error' : 'exito',
        }
      })
    }))
  }
  /*
    rechazarTramiteAccion = (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.stopPropagation();
        this.setState({ validated: true });
      } else {
        rechazarTramite(
          this.props.match.params.idTramite,
          this.state.mensajeRechazar
        ).then((response) => {
          this.isRedirect = true;
          this.setState({
            openRechazar: false,
            openMsgVentana: true,
            msgVentana: response.mensaje,
            isRechazado: true,
          });
        });
      }
    };
  */

  handleclickOpenReasignar = () => {
    this.setState({ ventanaReasignar: true });
  };

  handleclickCloseReasignar = () => {
    this.setState({ ventanaReasignar: false });
  };


  handleClickOpen = () => {
    this.setState({ openRechazar: true });
  };
  handleCloseRechazar = () => {
    this.setState({
      openRechazar: false,
    });
  };

  reasignarTramite = (idMiembroReasignado) => {
    if (!idMiembroReasignado) return;

    reasignarTramite(this.props.match.params.idTramite, idMiembroReasignado)
      .then((response) => {
        this.props.history.push({
          pathname: '/bandeja/pendientes',
          state: {
            mostrarMensajeFlash: true,
            mensajeFlash: response.mensaje,
            mensajeFlashSeverity: response.error ? "error" : "exito"
          }
        })
      })
      .catch((error) => {
        this.setState({
          openMsgVentana: true,
          msgVentana: "Error al reasignar trámite",
          error: true,
          ventanaReasignar: false
        });
      });
  };


  render() {
    const containerStyle = {
      display: "flex",
      flexDirection: "column",
      height: "100%",
    };

    const canvasStyle = {
      flex: 1,
      width: "100%",
      height: "100%",
    };
    return (
      <div className="template-base">

        <SeleccionPca
          ref={this.modalSeleccionPsa}
          isOpen={this.state.openSeleccionPca}
          cerrarModal={this.handleClosePsa}
          url={window.location.href}
          listaPsa={this.state.psaActivos}
        />

        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={"/bandeja/pendientes"}
              breadcrumbs={[
                { label: "Bandeja de tramites", path: "" },
                { label: "Tramites pendientes", path: "" },
              ]}
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title">
                  Firmar tramite
                </h1>
                <p className="page-description">
                  Puedes firmar el documento eligiendo primero la apariencia de
                  firma y luego haciendo click en Firmar y Enviar
                </p>
              </div>
              <div className="head-actions">
                {this.state.tieneAdjunto && (
                  <button
                    onClick={this.descargarAdjunto}
                    className="btn-medium btn-base-outline"
                  >
                    {" "}
                    <span className="material-symbols-outlined">
                      {" "}
                      download{" "}
                    </span>{" "}
                    Descargar adjuntos{" "}
                  </button>
                )}

                {this.state.supervisores.some(s => s.username === username()) && (
                  <button
                    onClick={this.handleclickOpenReasignar}
                    className="btn-medium btn-primary-tonal"
                  >
                    {" "}
                    <span className="material-symbols-outlined">
                      {" "}
                      sync_alt{" "}
                    </span>{" "}
                    Reasignar{" "}
                  </button>
                )}

                {this.state.supervisores.some(s => s.username === username()) && (
                  <button className="btn-medium btn-danger" onClick={this.handleClickOpen}>
                    <span className="material-symbols-outlined">close</span>
                    Rechazar
                  </button>
                )}

                <button
                  onClick={this.guardar}
                  disabled={!this.state.esSolicitante && !(this.state.idTipoDetalleEmpleado > 0)}
                  className="btn-medium btn-primary"
                >
                  {" "}
                  <span className="material-symbols-outlined">
                    {" "}
                    history_edu{" "}
                  </span>{" "}
                  Firmar y Enviar{" "}
                </button>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="component-documento">
            <div className="page-container container-sm">
              <div className="card">
                <div className="config-area">
                  {!this.state.esSolicitante && (
                    <>
                      <h3 className="form-subtitle"> Firma de Colaborador </h3>
                      <div className="form-group">
                        <select
                          className="form-select"
                          id="idTipoDetalleEmpleado"
                          name="idTipoDetalleEmpleado"
                          onChange={this.handleInput}
                          value={this.state.idTipoDetalleEmpleado}
                        >
                          <option value=""> </option>
                          {this.state.tipoDetalleEmpleado.map((elemento) => (
                            <option key={elemento.id} value={elemento.id}>
                              {elemento.name}
                            </option>
                          ))}
                        </select>
                        <label
                          htmlFor="idTipoDetalleEmpleado"
                          className="form-label"
                        >
                          {" "}
                          Detalles de apariencia de firma{" "}
                        </label>
                      </div>

                      {this.state.idTipoDetalleEmpleado == 2 ||
                        this.state.idTipoDetalleEmpleado == 3 ? (
                        <div className="inline-group">
                          {this.state.usuarioDetalle.map((elemento) => (
                            <div className="form-group">
                              <input
                                key={elemento.id}
                                type="checkbox"
                                className="form-check"
                                onClick={this.handeCheckEmpleado}
                                name="checkEmpleado"
                                id="checkEmpleado"
                                value={elemento.id}
                              />
                              <label
                                htmlFor="checkEmpleado"
                                className="check-label"
                              >
                                {" "}
                                {elemento.name}{" "}
                              </label>
                            </div>
                          ))}
                        </div>
                      ) : null}

                      {this.state.idTipoAparienciaEmpleado == 2 ? (
                        <div className="form-group">
                          <input
                            className="form-input inputFile"
                            type="file"
                            id="formFile"
                            accept=".png"
                            onChange={this.handleUploadLogoEmpleado}
                          />
                        </div>
                      ) : null}
                    </>
                  )}
                </div>
                  <div className="canvas-container">
                    <canvas id="the-canvas"></canvas>
                    <canvas className="upper-canvas"></canvas>
                  </div>
              </div>
            </div>
          </div>
          <ModalMensajePersonalizado
            isOpen={this.state.openMsgVentana}
            error={this.state.error}
            msg={this.state.msgVentana}
            accion={() => this.handleMsgVentana(false)}
            onClose={() => this.setState({ openMsgVentana: false })}
          />
          <ModalReasignarTramite
            ref={this.modalReasignarTramite}
            isOpen={this.state.ventanaReasignar}
            cerrarModal={this.handleclickCloseReasignar}
            onConfirmar={this.reasignarTramite}
          />
          <ModalRechazarRecibo
            ref={(ref) => (this.modalRechazarRecibo = ref)}
            isOpen={this.state.openRechazar}
            cerrarModal={this.handleCloseRechazar}
            onConfirmar={this.rechazarTramiteAccion}
          />

        </div>
        <PinTramite
          idTramite={this.props.match.params.idTramite}
          dialogTitle={"Firmar tramite"}
          fechaCarga={this.state.fechaCarga}
          nombre={this.state.nombreTramite}
          isOpen={this.state.dialogPinOpen}
          handleClose={(open, data) => {
            if (data && data.error) {
              this.setState({
                msgVentana: data.mensaje || "Error al cargar datos de firma.",
                openMsgVentana: true,
                error: true,
                dialogPinOpen: false,
              });
            } else if (typeof open === "boolean") {
              this.handleDialogPin(open, data);
            }
          }}
        />
      </div>
    );
  }
}

export default FirmarTramite;
